export default "__VITE_ASSET__DGFE1pkM__"